import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'
import { FC, useState } from 'react'

import { SlideIn } from '../Animation/SlideIn'
import { IconButton, Settings } from '../Icons'
import { Overlay } from '../Overlay'
import { CurrencyCombinationDisclosure } from './CurrencyCombinationDisclosure'
import { ExchangeOverlay } from './ExchangeOverlay'
import { ExpertMode } from './ExpertMode'
import { SlippageToleranceDisclosure } from './SlippageToleranceDisclosure'
// import { UserDeadlineDisclosure } from './UserDeadlineDisclosure'

interface SettingsOverlay {
  chainId: ChainId
  userExpertMode: boolean
}

export const SettingsOverlay: FC<SettingsOverlay> = ({
  chainId,
  userExpertMode
}) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <div className="grid grid-flow-col gap-4">
        <IconButton
          className="flex items-center hover:animate-spin-slow min-w-5 min-h-5"
          onClick={() => setOpen(true)}
        >
          <Settings
            className="stroke-slate-600 fill-transparent hover:stroke-slate-800"
            width={24}
            height={24}
          />
        </IconButton>
      </div>
      <SlideIn>
        <SlideIn.FromLeft show={open} onClose={() => setOpen(false)}>
          <Overlay.Content className=" backdrop-blur-10xl bg-gray-100/90 shadow shadow-slate-800 !pb-0">
            <div className="h-full px-3 -ml-3 -mr-3 overflow-x-hidden overflow-y-auto scroll">
              <Overlay.Header onClose={() => setOpen(false)} title="Settings" />
              <div className="px-1">
                <SlippageToleranceDisclosure chainId={chainId}/>
                {/* <UserDeadlineDisclosure
                  updateTransactionDeadlineType={updateTransactionDeadlineType}
                  userDeadlineType={userDeadlineType}
                  userDeadline={userDeadline}
                  updateTransactionDeadline={updateTransactionDeadline}
                />*/}
                <ExpertMode />
                {userExpertMode && (
                  <>
                    <CurrencyCombinationDisclosure chainId={chainId} />
                    <ExchangeOverlay />
                  </>
                )}
              </div>
            </div>
          </Overlay.Content>
        </SlideIn.FromLeft>
      </SlideIn>
    </>
  )
}
